// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1h-e";
export var animationRelative = "_1h-d";
export var backdropBlur = "_1h-0";
export var detailLabelCell = "_1h-q";
export var detailTable = "_1h-p";
export var detailValueCell = "_1h-r";
export var documentTypeIcon = "_1h-y";
export var documentTypeOption = "_1h-x";
export var dropdownMatchDatePicker = "_1h-3";
export var evidenceCardContent = "_1h-w";
export var gorgiasTicketCard = "_1h-s";
export var iconTertiary = "_1h-z";
export var integrationCard = "_1h-1";
export var integrationLogoBox = "_1h-2";
export var mainColumnSticky = "_1h-v";
export var maxWidthContainer = "_1h-t";
export var modalContentBody = "_1h-a";
export var modalHeaderImage = "_1h-5";
export var modalImageLabel = "_1h-7";
export var modalImageOverlay = "_1h-6";
export var modalImageSubtitle = "_1h-9";
export var modalImageTitle = "_1h-8";
export var modalImageWrapper = "_1h-4";
export var modalStickyFooter = "_1h-b";
export var sidebarColumn = "_1h-u";
export var timelineLine = "_1h-m";
export var timelineLineBlack = "_1h-o _1h-m";
export var timelineLineGray = "_1h-n _1h-m";
export var timelineLineHeight = "_1h-l";
export var tlDotActivate = "_1h-i";
export var tlDotActivateAnim = "_1h-h";
export var tlDotHide = "_1h-g";
export var tlDotHideAnim = "_1h-f";
export var tlLineActivate = "_1h-k";
export var tlLineActivateAnim = "_1h-j";
export var uploadedFileRow = "_1h-c";